/* prettier-ignore */

import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { RegisterComponent } from '../register/register.component';
import { StatisticsService } from 'src/app/services/statistics.service';
import { RestService } from 'src/app/services/rest.service';
import { catchError } from 'rxjs/operators';
import { DebugService } from 'src/app/services/debug.service';
import { UserService } from 'src/app/services/user.service';
import { of, throwError } from 'rxjs';
import Swal from'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent {
    passwordType: any = 'password';
    public loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(6)]),
        remember: new FormControl(false),
    });
    
  constructor(
    public rest: RestService,
    public modalCtrl: ModalController, 
    public authService: AuthService,
    public userService: UserService,
    public tools: ToolsService,
    public translate: TranslateService,
    private debugService: DebugService,
    private stats: StatisticsService
  ) {}

  login(){
    const payload = { 
      email: this.loginForm.get('email').value, 
      password: this.loginForm.get('password').value, 
      remember: this.loginForm.get('remember')?.value 
    }

    this.authService.login(payload.email, payload.password, payload.remember)
    .pipe(
      catchError((err) => {
        Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Usuario y/o contraseña incorrectos`) })
        return throwError(() => new Error('HTTP request failed', { cause: err }));
      })
    )
    .subscribe((res: any) => { 
      this.debugService.debug(res, '[LoginComponent] Login API Response');
      if (res.id){
        this.stats.login = payload.email;
        this.userService.checkAllUserEntries();
        this.dismissModal();
        return;
      }
      Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Usuario y/o contraseña incorrectos`) })
    })
  }

  dismissModal(){
    this.modalCtrl.dismiss();
  }

  showPassword(){
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
  }

  focusin(evt) {
    evt.stopPropagation();
  } 

  async register(){
    this.modalCtrl.dismiss()
    const registerModal = await this.modalCtrl.create({
        component: RegisterComponent,
        cssClass: 'registerModal',
    });
    await registerModal.present();
  }

  recoverPassword(){
    const url = `${this.rest.apiUrlBase}/api/forgot-password`
    window.open(url, "_blank");
  }

}